import { useEffect, useState } from "react";

export const useSearchParams = (paramKey) => {
  const [state, setState] = useState("");

  useEffect(() => {
    if (!window.location.search) setState(null);
    const searchParams = new URLSearchParams(window.location.search);
    const paramValue = searchParams.get(paramKey);
    setState(paramValue);
  }, [paramKey]);

  return state;
};
